var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThirdStepJourneyOld = function SvgThirdStepJourneyOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.189 8.802a.804.804 0 0 0 .032 1.145.81.81 0 1 0 0-1.145zm-.094-.337a1.147 1.147 0 1 1-.109 1.725 1.14 1.14 0 0 1-.041-1.621l.1-.104zm-.623-.38L6.778 2.79a.813.813 0 0 1 1.144 0l1.424 1.424a.813.813 0 0 1 0 1.144L4.05 10.664a1.824 1.824 0 0 1-2.578-2.579m2.817 2.818a2.161 2.161 0 0 1-3.056-3.056L6.54 2.55a1.15 1.15 0 0 1 1.62 0l1.425 1.425a1.15 1.15 0 0 1 0 1.62z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.25 11.534a1.15 1.15 0 0 0 1.15-1.15v-2.02a1.15 1.15 0 0 0-1.15-1.15H7.977l-3.688 3.689a2.15 2.15 0 0 1-1.525.631zm-5.78-.337h5.78a.813.813 0 0 0 .813-.813v-2.02a.813.813 0 0 0-.813-.812H8.117l-3.59 3.59z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M.939 1.886v7.489a1.822 1.822 0 1 0 3.644 0v-7.49a.813.813 0 0 0-.812-.812H1.75a.813.813 0 0 0-.812.813m.675 7.49a1.153 1.153 0 1 1 1.146 1.146h-.001l.002-.337v.337H2.76a1.15 1.15 0 0 1-1.146-1.146m.337-.001h-.337v.002zm-1.35 0v-7.49a1.15 1.15 0 0 1 1.15-1.15h2.02a1.15 1.15 0 0 1 1.15 1.15v7.49a2.16 2.16 0 0 1-4.32 0",
    clipRule: "evenodd"
  })));
};
export default SvgThirdStepJourneyOld;